export default __webpack_public_path__ + "static/media/Ab5.25df54f4.mp3";